import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=32a8397e&scoped=true&"
import script from "./Mobile.vue?vue&type=script&lang=ts&"
export * from "./Mobile.vue?vue&type=script&lang=ts&"
import style0 from "./Mobile.vue?vue&type=style&index=0&id=32a8397e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a8397e",
  null
  
)

export default component.exports